import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

/**
 * Loads the Meta Pixel script and fires a PageView event on mount.
 * Pixel ID is hardcoded — change here if it needs to be updated.
 */
export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.fbq) {
      // Already initialized — just fire PageView again
      window.fbq('track', 'PageView')
      return
    }

    // Meta Pixel base code
    ;(function (f: any, b: Document, e: string, v: string) {
      let n: any
      if (f.fbq) return
      n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    if (window.fbq) {
      window.fbq('init', pixelId)
      window.fbq('track', 'PageView')
    }

    // Add noscript fallback img
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    img.alt = ''
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript)
    }
  }, [pixelId])
}
